import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from "./components/contexts/AuthContext";
import { PricingProvider } from "./components/contexts/PricingContext";
import Configurator from "./components/Configurator/Configurator";
import ProtectedRoute from "./components/utils/ProtectedRoute";
import "./index.css";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './i18n';

// Code splitting (lazy loading) for secondary routes
const AdminPanel = lazy(() => import("./components/Admin/AdminPanel"));
const LoginPage = lazy(() => import("./components/Auth/LoginPage"));
const RegisterPage = lazy(() => import("./components/Auth/RegisterPage"));
const ForgotPasswordPage = lazy(() => import("./components/Auth/ForgotPasswordPage"));
const ResetPasswordPage = lazy(() => import("./components/Auth/ResetPasswordPage"));

function App() {
  return (
    <Suspense fallback={<div className="min-h-screen flex items-center justify-center font-medium text-gray-500">Завантаження...</div>}>
      <AuthProvider>
        <PricingProvider>
          <Router>
            <div className="App-container h-screen flex flex-col bg-gray-100 text-gray-800">
              <Routes>
                <Route path="/login" element={<LoginPage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
                
                <Route element={<ProtectedRoute />}>
                  <Route path="/" element={<Configurator />} />
                  <Route path="/admin" element={
                    <ProtectedRoute adminOnly={true}>
                      <AdminPanel />
                    </ProtectedRoute>
                  } />
                </Route>
                
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
              <ToastContainer theme="light" position="bottom-right" autoClose={3000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            </div>
          </Router>
        </PricingProvider>
      </AuthProvider>
    </Suspense>
  );
}

export default App;
